"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var singpassContainerStyles = makeStyles_1.default(function (_a) {
    var _b;
    var palette = _a.palette, breakpoints = _a.breakpoints;
    return ({
        root: {
            backgroundColor: palette.common.white,
        },
        disclaimerContainer: {
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 0',
            '& strong': {
                color: palette.secondary.main,
            },
        },
        singpassContainer: (_b = {
                marginBottom: 20
            },
            _b[breakpoints.down('xs')] = {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            },
            _b),
        titleContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
        description: {
            margin: '8px 0',
        },
    });
}, { name: 'Checkout4_SingpassContainer' });
exports.default = singpassContainerStyles;
